export enum AgencyEmailType {
  Business = 'Business',
  Personal = 'Personal',
}
